"use client";

import { useRouter } from "next/navigation";
import { useState } from "react";

import "@/features/v2/generalStyles.css";

import "./register.css";

import { IoIosArrowBack } from "react-icons/io";

import ContainerGift from "@/features/v2/auth/register/page/components/ContainerGift";
import HeaderForm from "@/features/v2/auth/register/page/components/HeaderForm";
import { useAuthErrorFromUrl } from "@/features/v2/auth/register/page/hooks/useAuthErrorFromUrl";
import { RegisterMethods } from "@/features/v2/auth/register/RegisterMethods";

type GiftChoices = "casino" | "sports" | undefined;

export const RegisterPageClient = () => {
  const [selectedGift, setSelectedGift] = useState<GiftChoices>(undefined);
  const [mainView, setMainView] = useState<GiftChoices>(undefined);
  const router = useRouter();

  useAuthErrorFromUrl();

  const handleBack = () => {
    if (mainView) {
      setMainView(undefined);
      setSelectedGift(undefined);
    } else {
      router.push("/");
    }
  };
  return (
    <main className="min-h-screen max-w-screen overflow-x-hidden overflow-y-auto flex flex-col items-center relative">
      <div className="absolute inset-0 bg-[linear-gradient(to_bottom,#1A0538,#3D0F6B)]" />
      <div className="absolute inset-0 bg-[url('/img/v2/register/pattern.webp')] bg-auto opacity-5 h-full w-full" />
      <div
        className="absolute inset-0
              bg-[repeating-conic-gradient(from_0deg,rgba(255,255,255,0.03)_0deg_5deg,transparent_5deg_10deg)]
              mask-image-[radial-gradient(circle_at_center,_black_30%,_transparent_100%)]
              [-webkit-mask-image:radial-gradient(circle_at_center,black_30%,transparent_100%)]
              opacity-80"
      />
      <div className="absolute inset-0 w-full h-full bottom-0" style={{ background: "linear-gradient(to top, #2F0940e0 0%, transparent 70%)" }} />
      <button
        type="button"
        className="text-2xl absolute left-4 top-4 border border-default-900 rounded-full p-2 z-60"
        onClick={() => {
          return handleBack();
        }}
      >
        <IoIosArrowBack size={24} />
      </button>
      {!mainView && (
        <div className="flex items-center justify-center min-h-screen w-full relative z-10">
          <ContainerGift selectedGift={selectedGift} setSelectedGift={setSelectedGift} setView={setMainView} />
        </div>
      )}
      {mainView && selectedGift && (
        <div className="flex flex-col items-center justify-start w-full z-10 px-4">
          <div className="w-full max-w-md flex flex-col items-center gap-4">
            <HeaderForm view={selectedGift} />
            <RegisterMethods welcomeBonus={selectedGift} />
          </div>
        </div>
      )}
    </main>
  );
};
